import { Button, Tabs } from 'antd';
import { ChevronLeft, Download } from 'lucide-react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { If } from '@components/condition';
import { userActions } from '@store/actions';
import { userSelector } from '@store/user/user.slice';

import ProductPriceProposalTable from './ProductPriceProposalTable';
import ProductPriceTable from './ProductPriceTable';
import { notify } from '@utils/notify';
import productPriceApi from '@apis/productPrice';

export function CustomPrice() {
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);
  const [tab, setTab] = useState('used');
  const [loading, setLoading] = useState(false);

  const exportProductPrice = async () => {
    try {
      setLoading(true);
      const res = await productPriceApi.exportProductPrice({
        userId: user?._id || '',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Bảng báo giá.xlsx`);
      document.body.appendChild(link);
      link.click();
      notify.success('Xuất file Excel thành công!');
    } catch (error: any) {
      notify.error(error?.message || 'Xuất file thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 lg:p-10">
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="flex items-center gap-2 text-xl lg:text-2xl font-semibold text-gray-900 mb-2">
          <ChevronLeft
            className="cursor-pointer lg:hidden"
            onClick={() => {
              dispatch(userActions.self.setShowProfileSider(true));
            }}
            size={32}
          />
          BÁO GIÁ
        </h1>
        <p className="text-gray-600 text-sm">
          Giá sản phẩm sẽ được thương lượng và cập nhật hàng tháng.
        </p>
      </div>
      {/* Content Grid */}
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-4">
        <Tabs
          onChange={(activeKey) => {
            setTab(activeKey);
          }}
          items={[
            { key: 'used', label: <span className="font-medium">Giá hiện tại</span> },
            {
              key: 'proposal',
              label: <span className="font-medium">Giá đề xuất</span>,
            },
          ]}
        />
        <Button
          loading={loading}
          onClick={exportProductPrice}
          type="primary"
          className="h-10 max-w-xs"
        >
          <Download strokeWidth={3} className="w-4 h-4" />
          Xuất báo giá
        </Button>
      </div>
      <If
        condition={tab === 'used'}
        Then={<ProductPriceTable userId={user?._id} />}
        Else={<ProductPriceProposalTable userId={user?._id} />}
      />
    </div>
  );
}
